import React, { useContext } from 'react';
import { Button, Checkbox, Flex, Spinner, Text } from "@chakra-ui/react";
import { PayRentPropTypes } from "../PayRentPropTypes";
import { localisable } from "../../../generic/localisable";
import { useState, useEffect } from 'react';
import { renderCardRadioButtonSelection, renderDropDown, renderExistingCardDetails } from "../Utils";
import { checkboxStyle, emailFormButtonProps, onSubmitLoaderStyle, payRentMainContainerProps } from "../constants";
import { Form } from 'react-final-form';
import { HOSTED_FORM_ID } from 'components/SyrapayHostedForm/Constants';
import { getIndivCookie } from '../../../utils/auth';
import { PaymentContext } from 'components/context/PaymentContext';
import { getAuthKey, signUpForSyraPayAutoPay, autoPayOptOut } from '@v10-codeparva/v10-tfw-revamp-package-api';
import SyrapayHostedForm from 'components/SyrapayHostedForm/SyrapayHostedForm';
import { navigate } from '@reach/router';

export const AutoPaySyrapay = ({
    cardList,
    existingCardDetails,
    shallRenderCardIcons,
    IsAutoPaymentsEnabled,
    IsAutoPaymentsForced,
    IsOptingOutAutoPaymentRestricted,
    updateAutoPayHandler,
    logOffHandler,
    PreferredPaymentMethod
}: PayRentPropTypes.TAutoPayProps) => {

    const [selectedPaymentMode, setSelectedPaymentMode] = useState('');
    const [cardOpted, setCardOpted] = useState('existingCard');
    const [isAutopayChecked, setIsAutopayChecked] = useState(IsAutoPaymentsEnabled);
    const [payTypeDescription, setPayTypeDescription] = useState('');
    const [authKey, setAuthKey] = useState('');
    const cToken = getIndivCookie('cToken');
    const paymentContext = useContext(PaymentContext);
    const [showHostedForm, setShowHostedForm] = useState(false);
    const [disableSubmitButton, setDisableSubmitButton] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (IsAutoPaymentsForced) {
            setIsAutopayChecked(true);
        } else {
            setIsAutopayChecked(IsAutoPaymentsEnabled);
        }
    }, [IsAutoPaymentsForced, IsAutoPaymentsEnabled]);

    useEffect(() => {
        if (IsAutoPaymentsEnabled === isAutopayChecked) {
            setDisableSubmitButton(true);
        } else {
            setDisableSubmitButton(false);
        }
    }, [isAutopayChecked]);

    useEffect(() => {
        const selectedPayType = cardList.find(({ PayTypeID }) => PayTypeID == selectedPaymentMode);

        if (selectedPayType) {
            setPayTypeDescription(selectedPayType.PayTypeDescription);
        }
    }, [selectedPaymentMode]);

    const renderCheckBox = () => {
        return (
            <Flex alignItems='baseline' gap='16px' maxW={{ base: '100%', sm: '480px' }}>
                <Checkbox
                    isChecked={isAutopayChecked}
                    onChange={() => setIsAutopayChecked(!isAutopayChecked)}
                    isDisabled={!!IsAutoPaymentsForced || (IsOptingOutAutoPaymentRestricted && IsAutoPaymentsEnabled)}
                    {...checkboxStyle}
                />
                <Text textStyle='body1'>{localisable.autoPaymentContent}</Text>
            </Flex>
        )
    };

    // const handleSubmit = () => {

    //     const { CCNumber, CCBillingAccountName, CCExpirationMonth, CCExpirationYear, CCBillingAddress, CCBillingZIP } = existingCardDetails || {};

    //     const payloadForExistingCard = {
    //         objPayment: {
    //             SignUpForAutoPay: isAutopayChecked,
    //             intPreferredPaymentMethod: PreferredPaymentMethod,
    //             CCNumber: CCNumber,
    //             CCBillingAccountName: CCBillingAccountName,
    //             CCExpirationMonth: CCExpirationMonth,
    //             CCExpirationYear: CCExpirationYear,
    //             CCBillingAddress: CCBillingAddress,
    //             CCBillingZIP: CCBillingZIP,
    //             PayType: {
    //                 "PayTypeDescription": payTypeDescription,
    //                 "PayTypeID": selectedPaymentMode
    //             }
    //         },
    //     };

    //     const payloadForNewCard = {
    //         blnForAutoPay: isAutopayChecked,
    //     };

    //     updateAutoPayHandler(cardOpted === 'existingCard' ? payloadForExistingCard : payloadForNewCard);
    // };

    const renderButtonSection = (dirty: boolean) => {
        return (
            <Flex>
                <Flex direction={{ base: 'column', sm: 'row' }} gap='16px' justifyContent={{ sm: 'flex-end' }}>
                    <Button
                        {...emailFormButtonProps}
                        type='submit'
                        bg='brand.lightTertiary'
                        minW={{ base: '100%', sm: '204px' }}
                        w='fit-content'
                        isDisabled={!dirty && disableSubmitButton}
                    >
                        <Text textStyle='buttonSmall' color='brand.secondary' >{localisable.updateAutoPayStatus}</Text>
                    </Button>
                    <Button
                        {...emailFormButtonProps}
                        onClick={() => logOffHandler()}
                        bg='brand.lightTertiary'
                        minW={{ base: '100%', sm: '204px' }}
                    >
                        <Text textStyle='buttonSmall' color='brand.secondary' >{localisable.logOff}</Text>
                    </Button>
                </Flex>
            </Flex>
        )
    };

    const fetchAuthKey = async () => {
        setIsLoading(true);
        const authKeyReq = {
            blnForAutopay: true,
            token: cToken,
            cid: process.env.CID || '',
        }
        const authKeyResponse = await getAuthKey(authKeyReq);
        setIsLoading(false);
        const {
            strAuthenticationKey
        } = authKeyResponse;
        paymentContext?.setAuthenticationKey(strAuthenticationKey);
        setAuthKey(strAuthenticationKey);
        setShowHostedForm(true);
    }

    const paymentCancellationHandler = () => {
        setShowHostedForm(false);
        setDisableSubmitButton(false);
        setIsLoading(false);
    };

    const handleFormSubmit = async (otherResponse: any) => {
        setIsLoading(true);
        const signUpAutoPayReq = {
            SignUpForAutoPay: true,
            intPreferredPaymentMethod: Number(selectedPaymentMode),
            strHostedGatewayResponse: otherResponse,
            token: cToken,
            cid: process.env.CID || '',
        };
        const autoPayResponse = await signUpForSyraPayAutoPay(signUpAutoPayReq);
        const {
            blnSuccess
        } = autoPayResponse;
        setIsLoading(false);
        if (blnSuccess) {
            const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
            const pathSegments = currentPath.split('/');
            // Keep only the segments up to and including "pay-rent"
            const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
            navigate(`${basePath}/auto-pay-change`, {
                state: {
                    message: 'Sign Up Auto Pay is Completed.'
                }
            })
        }
    };

    const existingCardAutoPay = async () => {
        setIsLoading(true);
        const { CCBillingAccountName, CCBillingAddress, CCBillingZIP, CCExpirationMonth, CCExpirationYear, CCNumber } = existingCardDetails;
        const signUpAutoPayReq = {
            CCBillingAccountName,
            CCBillingAddress,
            CCBillingZIP,
            CCExpirationYear,
            CCExpirationMonth,
            CCNumber,
            payTypeDescription: payTypeDescription,
            SignUpForAutoPay: true,
            intPreferredPaymentMethod: Number(selectedPaymentMode) || PreferredPaymentMethod || 0,
            token: cToken,
        };
        const autoPayResponse = await signUpForSyraPayAutoPay(signUpAutoPayReq);
        setIsLoading(false);
        const {
            blnSuccess
        } = autoPayResponse;
        if (blnSuccess) {
            const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
            const pathSegments = currentPath.split('/');
            // Keep only the segments up to and including "pay-rent"
            const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
            navigate(`${basePath}/auto-pay-change`, {
                state: {
                    message: 'Sign Up Auto Pay is Completed.'
                }
            })
        }
    };

    const optOutAutoPay = async () => {
        setIsLoading(true);
        const optOutAutoPayReq = {
            token: cToken,
            cid: process.env.CID || '',
        }
        const optOutResponse = await autoPayOptOut(optOutAutoPayReq)
        const {
            data: {
                blnSuccess
            }
        } = optOutResponse;
        setIsLoading(false);
        if (blnSuccess) {
            const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
            const pathSegments = currentPath.split('/');
            // Keep only the segments up to and including "pay-rent"
            const basePath = pathSegments.slice(0, pathSegments.indexOf('pay-rent') + 1).join('/');
            navigate(`${basePath}/auto-pay-change`, {
                state: {
                    message: 'Signed Out of Auto Pay is Completed.'
                }
            })
        }
    };
    const Loader = () => {
        return (
            <Flex {...onSubmitLoaderStyle}>
                <Spinner size={'xl'} />
            </Flex>
        );
    };

    return (
        <Form
            onSubmit={async () => {
                if (cardOpted === 'newCard' && isAutopayChecked) {
                    setDisableSubmitButton(true);
                    await fetchAuthKey();
                } else if (isAutopayChecked) {
                    setDisableSubmitButton(true);
                    existingCardAutoPay()
                } else {
                    setDisableSubmitButton(true);
                    optOutAutoPay()
                }
            }}
            render={({ handleSubmit, dirty }) => {
                return <form
                    id={HOSTED_FORM_ID}
                    onSubmit={handleSubmit}
                >
                    <Flex {...payRentMainContainerProps}>
                        <Flex direction='column' w='100%' padding={{ sm: '0px 96px' }} gap='32px'>
                            <Text textStyle='h2' borderBottom={'1px solid'} paddingBottom={'32px'}>{localisable.autoPaySignup}</Text>
                            {isLoading && <Loader />}
                            <Flex direction='column' gap='24px'>
                                {(cardOpted === 'newCard') && renderDropDown(false, undefined, cardList, shallRenderCardIcons,
                                    selectedPaymentMode, setSelectedPaymentMode, 0, undefined, undefined)}
                                {renderCheckBox()}
                                {renderCardRadioButtonSelection(cardOpted, setCardOpted, 0, setSelectedPaymentMode,
                                    undefined, undefined, PreferredPaymentMethod)}
                                {(cardOpted === 'existingCard') && renderExistingCardDetails(existingCardDetails)}
                                {renderButtonSection(dirty)}
                            </Flex>
                        </Flex>
                        {
                            cardOpted === 'newCard' && showHostedForm ?
                                <SyrapayHostedForm
                                    amount='0'
                                    authKey={authKey}
                                    shouldSaveCard={true}
                                    tokenOnly={true}
                                    paymentCancellationHandler={paymentCancellationHandler}
                                    hostedFormSubmitHandler={handleFormSubmit}
                                /> :
                                <></>
                        }
                    </Flex >
                </form>
            }}

        >

        </Form>

    )
};